<template>
  <div>
    <textarea
      ref="editor"></textarea>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  watch: {
    value(newValue) {
      // eslint-disable-next-line
      let editor = tinymce.get(this.$refs.editor.id);

      if (editor && editor.getContent() !== newValue) {
        editor.setContent(newValue);
      }
    }
  },
  mounted() {
    // eslint-disable-next-line
    tinymce.init({
      target: this.$refs.editor,
      height: 500,
      menubar: false,
      placeholder: this.$t('order.addIndentOfferServicesDescription'),
      plugins: 'table code fullscreen image',
      advcode_inline: true,
      paste_data_images: true,
      automatic_uploads: false,
      toolbar1: 'fullscreen | undo redo | bold italic backcolor | alignleft aligncenter alignright alignjustify | image | bullist numlist outdent indent | removeformat code',
      toolbar2: 'table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
      setup: (editor) => {
        editor.on('init', () => {
          editor.setContent(this.value);
        });
        editor.on('change keyup', () => {
          let content = editor.getContent();
          this.$emit('input', content);
        });
      },
      file_picker_types: 'image',
      file_picker_callback: (cb) => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';

        input.onchange = () => {
          const file = input.files[0];
          const reader = new FileReader();

          reader.onload = () => cb(reader.result);
          reader.readAsDataURL(file);
        };

        input.click();
      },
      images_upload_url: null,
      images_upload_handler: null,
      branding: true
    });
  },
  beforeDestroy() {
    // eslint-disable-next-line
    if (tinymce.get(this.$refs.editor.id)) {
      // eslint-disable-next-line
      tinymce.get(this.$refs.editor.id).remove();
    }
  },
};
</script>
